import(/* webpackMode: "eager" */ "/vercel/path0/src/app/inspections/book/page.tsx");
